<template>
  <div>
    <bita-breadcrumb :items="breadCrumbs" />
    <div class="wrapper wrapper-content animated fadeInRight">
      <bita-ibox :is-loading="isLoadingGrid">
        <div slot="body">
          <bita-bootbutton
            title="افزودن"
            type="primary"
            icon="fas fa-plus-square"
            btn-width="200px"
            @click.native="add"
            v-if="$acl.can('create', 'sales-agents')"
          />
          <hr />
          <bita-grid
            ref="grid"
            :columns="gridColumns"
            :read-data="readData"
            :schema-total="'total'"
            :schema-data="'data'"
          />
        </div>
      </bita-ibox>
    </div>
    <sale-agent-form ref="SalesAgent" :title="title" @load-data="loadData" />
  </div>
</template>
<script>
import SaleAgentForm from "./components/SaleAgentForm.vue";
import { saleAgentApi } from "@/api/apiManagement.js";

export default {
  components: {
    SaleAgentForm
  },
  data() {
      return {
          breadCrumbs: [
              { title: "صفحه اصلی", link: "/" },
              { title: "عاملین فروش", link: "/management/sales-agents" },
          ],
          isLoadingGrid: false,
          title: "",
      }
  },
  computed: {
      gridColumns() {
          return [
              { title: "عنوان", field: "title" },
              { title: "تاریخ ایحاد", template: (e) => ( e.created_at ? this.$getJalaliDateTime(e.created_at) : '-' )},
              { title: "عملیات", command: this.gridCommands() }
          ]
      }
  },
  methods: {
    readData(e) {
      saleAgentApi.gets()
        .then( (res) => {
          e.success(res.data.entity);
        })
        .catch( () => e.success([]) );
    },
    loadData() {
      this.$refs.grid.loadDataSource();
    },
    gridCommands() {
      let commands = [];
      commands.push({
        text: "edit",
        click: this.edit,
        template: this.gridButtons.edit,
      });
      commands.push({
        text: "delete",
        click: this.delete,
        template: this.gridButtons.delete,
      });
      return commands;
    },
    add() {
      this.title = "افزودن";
      this.$refs.SalesAgent.setInitialData({});
      this.$toggleModal("#sale-agent-form");
    },
    edit(e) {
      let data = this.$refs.grid.getSelectedGridRow(e);
      this.title = "ویرایش";
      this.$refs.SalesAgent.setInitialData(data);
      this.$toggleModal("#sale-agent-form");
    },
    delete(e) {
      let data = this.$refs.grid.getSelectedGridRow(e);
      this.$alert(
        "question",
        `آیا از حذف این مورد اطمینان دارید ؟`,
        "",
        {
          confirmButtonText: "بله",
        }
      ).then((result) => {
        if (result.value) {
          this.isLoadingGrid = true;
          saleAgentApi
            .delete(data.id)
            .then((res) => {
              this.$izitoast("success", "عملیات موفق", res.data.message);
              this.loadData();
            })
            .finally(() => {
              this.isLoadingGrid = false;
            });
        }
      });
    },
  }
}
</script>